// Importing necessary dependencies and components
import React, { useState, useEffect } from 'react';  // Added useEffect for fetching
import Footer from '../../../footer.js'; // Footer component for the website footer
import { Link } from 'react-router-dom';  // Link component for navigation between pages
import { Button } from 'react-bootstrap';  // Bootstrap Button component for UI elements
import { AiOutlineFileAdd } from "react-icons/ai";  // Icon for file add button
import { BsPencilFill } from "react-icons/bs";  // Icon for edit button
import { BsFileEarmarkCode } from "react-icons/bs";  // Icon for file type button
import { LuFilter } from 'react-icons/lu';  // Filter icon
import { GrAttachment, GrInbox } from "react-icons/gr";  // Icons for attachments and inbox
// import Filter from '../../screens/cases/Filter.js';  // Custom Filter component
import { IoSettingsOutline } from "react-icons/io5";  // Settings icon
import Header from '../../../header/header.js';
import Navvbar from '../../../header/Navvbar.js';


// Define the OpenTryInCases component
const OpenTryInCases = () => {
  // State hooks for managing the component's state
  const [cases, setCases] = useState([]);  // MODIFIED: Added setCases to update from fetch
  const [dropdownVisible, setDropdownVisible] = useState(null);  // Controls visibility of dropdown for each case
  const [currentMonth] = useState(new Date().getMonth());  // Stores the current month
  const [currentYear] = useState(new Date().getFullYear());  // Stores the current year
  const [show, setShow] = useState(false);  // Controls the visibility of the modal
  const [loading, setLoading] = useState(true);  // NEW: Loading state for fetch
  const [error, setError] = useState(null);  // NEW: Error state for fetch

  // NEW: Fetch cases from API on mount
  useEffect(() => {
    const fetchCases = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://hms.backend.hiragroupcloud.com/api/cases/cases', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,  // Add if auth required
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch cases');
        }

        const data = await response.json();
        setCases(data);  // Set fetched cases (assuming array)
        setLoading(false);
      } catch (err) {
        console.error('Error fetching cases:', err);
        setError('Error loading cases. Please try again.');
        setLoading(false);
      }
    };

    fetchCases();
  }, []);  // Empty dependency: Fetch once on mount

  // MODIFIED: First filter try_in true, then by current month/year
  const filteredCases = cases
    .filter((caseItem) => caseItem.try_in === true)  // NEW: Only try_in true
    .filter((caseItem) => {
      const caseDate = new Date(caseItem.date);  // Converts case date to a Date object
      return caseDate.getMonth() === currentMonth && caseDate.getFullYear() === currentYear;  // Matches current month and year
    });

  // Toggles the visibility of the dropdown menu for a specific case
  const toggleDropdown = (caseId) => {
    setDropdownVisible(dropdownVisible === caseId ? null : caseId);  // Shows/hides the dropdown based on the caseId
  };

  // Shows the modal when the filter button is clicked
  const handleShowModal = () => {
    setShow(true);  // Sets show state to true, which triggers modal visibility
  };

  // Hides the modal
  const handleCloseModal = () => {
    setShow(false);  // Sets show state to false, hiding the modal
  };

  // NEW: Handle loading and error in UI
  if (loading) {
    return <p>Loading cases...</p>;
  }

  if (error) {
    return <p style={{ color: 'red' }}>{error}</p>;
  }

  return (
    <>
      <Header />
      <Navvbar/>
      <div style={{ marginTop: '20px', width: '95%', margin: '0 auto', padding: "0px" }}>
        {/* Header Section */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          {/* Title of the Section */}
          <h2 className="title" style={{ margin: 0, backgroundColor: "white" }}>
            Open Try-In Cases (£ 0.00)
          </h2>
        </div>

        {/* Filters Button */}
        <div className="col-md-0 d-flex justify-content-end">
          <button style={{
            padding: '5px', backgroundColor: '#004aad', color: 'white', width: '90px',
            height: '35px', border: 'none', borderRadius: '5px', cursor: 'pointer'
          }} onClick={handleShowModal}>
            {/* Icon and Label for Filter Button */}
            <LuFilter /> Filters
          </button>
        </div>

        {/* Spacing */}
        <br />
        <br />
        <div
          style={{
            width: "100%",
            margin: "0 auto",
            padding: "20px",
            border: "3px solid #f4f4f4",
            borderRadius: "5px",
          }}
        >
          {/* Table Section */}
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {/* Checkbox Column */}
                <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #ddd" }}>
                  <input type="checkbox" />
                </th>

                {/* Table Headers */}
                {[
                  "Inbox",
                  "Attachment",
                  "Case/Pan",
                  "Invoice",
                  "Account",
                  "Provider",
                  "Patient/Appt",
                  "Lab Ship",
                  "Account Ship",
                  "Delivery Date",
                ].map((header) => (
                  <th
                    key={header}
                    style={{
                      padding: "10px",
                      textAlign: "left",
                      borderBottom: "1px solid #ddd",
                      fontWeight: "bold",
                    }}
                  >
                    {/* Render specific icons for "Inbox" and "Attachment" */}
                    {header === "Inbox" ? (
                      <GrInbox style={{ fontSize: "20px" }} />
                    ) : header === "Attachment" ? (
                      <GrAttachment style={{ fontSize: "20px" }} />
                    ) : (
                      header
                    )}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {/* If there are filtered cases, render them */}
              {filteredCases.length > 0 ? (
                filteredCases.map((caseItem) => (
                  <tr
                    key={caseItem._id}
                    style={{ borderBottom: "1px solid #ddd", cursor: "pointer" }}
                  >
                    {/* Checkbox for each case */}
                    <td>
                      <input type="checkbox" />
                    </td>

                    {/* Icons */}
                    <td>
                      <GrInbox style={{ fontSize: "20px" }} />
                    </td>
                    <td>
                      <GrAttachment style={{ fontSize: "20px" }} />
                    </td>

                    {/* Case Details */}
                    <td style={{ padding: "10px", textAlign: "left", position: "relative" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <Link
                              to={`/case/${caseItem.caseNumber}`}
                              style={{
                                textDecoration: "none",
                                color: "#004aad",
                                fontSize: "17px",
                              }}
                            >
                              #{caseItem.caseNumber}
                            </Link>

                            {/* Settings Dropdown Button */}
                            <button
                              style={{
                                fontSize: "18px",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                padding: 0,
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleDropdown(caseItem._id);
                              }}
                            >
                              <IoSettingsOutline style={{ color: "#004aad", fontSize: "22px" }} />
                            </button>
                          </div>

                          {/* Pan Color */}
                          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <p style={{ margin: 0 }}>Pan Color:</p>
                            <span
                              style={{
                                width: "12px",
                                height: "12px",
                                backgroundColor: caseItem.color ? caseItem.color.toLowerCase() : "#ccc",
                                display: "inline-block",
                                borderRadius: "3px",
                              }}
                            ></span>
                            <span>{caseItem.color || "N/A"}</span>
                          </div>

                          {/* Quill Editor Content */}
                             {caseItem.procedures &&
                            caseItem.procedures.length > 0 ? (
                              <div style={{ fontSize: "14px" }}>
                                <ul
                                  style={{
                                    listStyleType: "none",
                                    paddingLeft: 0,
                                  }}
                                >
                                  {caseItem.procedures.map((proc, index) => (
                                    <li
                                      key={index}
                                      style={{ marginBottom: "5px" }}
                                    >
                                      {proc.procedure}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            ) : (
                              <div style={{ fontSize: "14px", color: "#666" }}>
                                No procedures selected
                              </div>
                            )}
                        </div>
                      </div>

                      {/* Dropdown Menu */}
                      {dropdownVisible === caseItem._id && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            right: "0",
                            backgroundColor: "#fff",
                            border: "1px solid #ccc",
                            padding: "10px",
                            borderRadius: "5px",
                            zIndex: 1000,
                            width: "150px",
                            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <ul style={{ listStyle: "none", padding: "0" }}>
                            <li style={{ padding: "8px 0", cursor: "pointer" }}>
                              <BsFileEarmarkCode /> Close/Invoice
                            </li>
                            <li style={{ padding: "8px 0", cursor: "pointer" }}>
                              <BsPencilFill /> Add Notes
                            </li>
                            <li style={{ padding: "8px 0", cursor: "pointer" }}>
                              <AiOutlineFileAdd /> Upload Files
                            </li>
                          </ul>
                        </div>
                      )}
                    </td>

                    {/* Invoice Number */}
                    <td style={{ padding: "10px", textAlign: "left" }}>
                      {caseItem.invoiceNumber || "N/A"}
                    </td>

                    {/* Account Holder */}
                    <td style={{ padding: "10px", textAlign: "left" }}>
                      <Link
                        to="/TabsWorking"
                        style={{
                          textDecoration: "none",
                          color: "#004aad",
                          fontSize: "16px",
                        }}
                      >
                        {caseItem.account_holder || "N/A"}
                      </Link>
                    </td>

                    {/* Provider Name */}
                    <td style={{ padding: "10px", textAlign: "left" }}>
                      {caseItem.provider_name || "N/A"}
                    </td>

                    {/* Last Name */}
                    <td style={{ padding: "10px", textAlign: "left" }}>
                      {caseItem.last_name || "N/A"}
                    </td>

                    {/* Dates */}
                    <td style={{ padding: "10px", textAlign: "left" }}>
                      {caseItem.start_date ? new Date(caseItem.start_date).toLocaleDateString() : "N/A"}
                    </td>
                    <td style={{ padding: "10px", textAlign: "left" }}>
                      {caseItem.arrive_date ? new Date(caseItem.arrive_date).toLocaleDateString() : "N/A"}
                    </td>
                    <td style={{ padding: "10px", textAlign: "left" }}>
                      {caseItem.date ? new Date(caseItem.date).toLocaleDateString() : "N/A"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center", padding: "20px" }}>
                    No cases available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <br/>

        {/* Pagination Buttons */}
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', width: '100%' }}>
          {/* 'First' Button */}
          <Button style={{ backgroundColor: "#f0f0f0", borderColor: "#ced4da", flex: 1, color: "black", marginRight: "0", borderRadius: '0' }} className="mx-0">First</Button>

          {/* 'Previous' Button */}
          <Button style={{ backgroundColor: "#f0f0f0", borderColor: "#ced4da", flex: 1, color: "black", marginRight: "0", borderRadius: '0' }} className="mx-0">Previous</Button>

          {/* Current Page Number (Button 1) */}
          <Button style={{ backgroundColor: "#004aad", borderColor: "#004aad", flex: 1, marginRight: "0", borderRadius: '0' }} className="mx-0">1</Button>

          {/* 'Next' Button */}
          <Button style={{ backgroundColor: "#f0f0f0", borderColor: "#ced4da", flex: 1, color: "black", marginRight: "0", borderRadius: '0' }} className="mx-0">Next</Button>

          {/* 'Last' Button */}
          <Button style={{ backgroundColor: "#f0f0f0", borderColor: "#ced4da", flex: 1, color: "black", marginRight: "0", borderRadius: '0' }} className="mx-0">Last</Button>
        </div>
      </div>

      {/* Render gray background overlay when modal is visible */}
      {show && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Gray transparent background
            zIndex: 999, // Ensure it's on top of other content
          }}
          onClick={handleCloseModal} // Close modal if clicking outside
        />
      )}

      {/* Render the FilterModal component
      <Filter show={show} handleClose={handleCloseModal} /> */}

      {/* Footer */}
      <div style={{ width: '95%', margin: '0 auto', padding: "0px" }}>
        <Footer />
      </div>
    </>
  );
};

export default OpenTryInCases;